import React from "react";

const ViewDescription = ({ title, onClose, children }) => {
  // Debugging: Check the actual children value
  console.log("Children Content:", children);

  // Extract text from React element children
  const descriptionText = React.Children.toArray(children)
    .map((child) => (typeof child === "string" ? child : child.props.children))
    .join("");
    
  //
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-color p-6 rounded-lg shadow-lg w-full max-w-2xl min-w-[300px] border-4 border-white flex flex-col">
        {/* Title */}
        <h2 className="text-2xl mb-4 text-white">{title}</h2>

        {/* Scrollable content, displayed line by line in column format */}
        <div className="flex flex-col gap-2 mb-4 max-h-[60vh] overflow-y-auto whitespace-pre-wrap">
          {descriptionText
            ? descriptionText.split("\n").map((line, index) => (
              <p key={index} className="mb-2 text-white">{line}</p>
            ))
            : "No Description Available"}
        </div>

        {/* Close Button */}
        <div className="text-right">
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewDescription;
